import { Routes } from '@angular/router';
import { ShellComponent } from '@adminprodigydesign/axis';
import { HomeComponent } from './pages/home/home.component';
import { shellRouteData } from '../assets/data/shell-data';
import { ServicesComponent } from './pages/services/services.component';
import { ContactComponent } from './pages/contact/contact.component';
import { AboutComponent } from './pages/about/about.component';

export const routes: Routes = [
  // {
  //   path: '',
  //   component: ShellComponent,
  //   data: shellRouteData,
  //   children: [
  //     { path: 'home', component: HomeComponent },
  //     { path: 'services', component: ServicesComponent },
  //     { path: 'contact', component: ContactComponent },
  //     { path: '', redirectTo: 'home', pathMatch: 'full' }, // default route
  //   ],
  // },
  { path: 'home', component: HomeComponent },
  { path: 'services', component: ServicesComponent },
  { path: 'contact', component: ContactComponent },
  { path: 'about-us', component: AboutComponent },
  { path: '', redirectTo: 'home', pathMatch: 'full' }, // default route
];
